import { useQuery } from "@tanstack/react-query";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import EnterpriseApiRoutes from "common/ApiRoutes";
import { onError } from "util/conditional/onError";
export const LICENSES_VALIDITY_KEY = "licenses_validity";
const INITIAL_DATA = {
  valid: false,
  expired: false,
  violated: false
};
const getLicenseValidityForSubject = (subject) => fetch("GET", qualifyUrl(EnterpriseApiRoutes.License.validityForSubject(subject).url));
const useLicenseValidityForSubject = (subject) => {
  const { data, isInitialLoading, refetch } = useQuery({
    queryKey: [LICENSES_VALIDITY_KEY, subject],
    queryFn: () => onError(getLicenseValidityForSubject(subject), (errorThrown) => {
      if (!(errorThrown.status === 404)) {
        UserNotification.error(`Loading license status for subject failed with: ${errorThrown}`);
      }
    }),
    retry: 0,
    // 10 min refetch interval,
    refetchInterval: 6e5
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isInitialLoading,
    refetch
  };
};
export default useLicenseValidityForSubject;
